import React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

const Popover = (props) => {
  return <PopoverPrimitive.Root data-slot='popover' {...props} />
}

function PopoverTrigger(props) {
  return <PopoverPrimitive.Trigger data-slot='popover-trigger' {...props} />
}

function PopoverContent({ style, align = 'center', sideOffset = 4, ...props }) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot='popover-content'
        align={align}
        sideOffset={sideOffset}
        style={{ ...style }}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}

function PopoverAnchor(props) {
  return <PopoverPrimitive.Anchor data-slot='popover-anchor' {...props} />
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
